import * as actionTypes from './../actions/bodyConditionAction';

const initialState = {
  selectedBodyWeight: null,
  selectedGoalWeight: null,
  data: [],
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT_BODY_WEIGHT:
      return {
        ...state,
        selectedBodyWeight: action.selectedBodyWeight,
      };
    case actionTypes.SELECT_GOAL_WEIGHT:
      return {
        ...state,
        selectedGoalWeight: action.selectedGoalWeight,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selectedBodyWeight: 0,
        selectedGoalWeight: 0,
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
